var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.subArea1)?_c('p',{staticClass:"rt-common-footer-text",domProps:{"innerHTML":_vm._s(_vm.subArea1)}}):_c('p',{staticClass:"rt-common-footer-text",domProps:{"innerHTML":_vm._s(_vm.fallback)}})
}
var staticRenderFns = []

export { render, staticRenderFns }